"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24GlobeFill = function Svg24GlobeFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M12.02 21.002h-.003.002zm.285-.302c-.16.21-.264.276-.305.294-.04-.018-.145-.083-.305-.294-.248-.326-.516-.862-.765-1.618-.424-1.287-.74-3.052-.868-5.082h3.876c-.128 2.03-.444 3.795-.868 5.082-.25.756-.517 1.292-.765 1.617zm-.322.301h-.002.002zm-5.133-1.62A9.01 9.01 0 0 1 3.223 14h2.832c.11 1.974.382 3.821.795 5.382zm0-14.763C6.437 6.18 6.165 8.026 6.055 10H3.223A9.01 9.01 0 0 1 6.85 4.618zm10.3 0A9.01 9.01 0 0 1 20.777 10h-2.832c-.11-1.974-.382-3.821-.795-5.382zm0 14.764c.413-1.561.685-3.408.795-5.382h2.832a9.01 9.01 0 0 1-3.627 5.382zM13.938 10h-3.876c.128-2.03.444-3.795.868-5.082.25-.756.517-1.292.765-1.618.16-.21.264-.276.305-.294.04.018.145.083.305.295.248.325.516.86.765 1.617.424 1.287.74 3.052.868 5.082zM12.02 2.998h-.002.002zm-.038 0h.002-.002z",
    fill: useDefaultColors ? '#191919' : fill,
    stroke: "#191919",
    strokeWidth: 2
  }));
};

Svg24GlobeFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24GlobeFill;
exports.default = _default;